// extracted by mini-css-extract-plugin
export default {"content":"DossierLayout_content__Py9vP","dossier":"DossierLayout_dossier__wCpc3","dossierContainer":"DossierLayout_dossierContainer__MDGvP"};